import { call, put } from "redux-saga/effects";
import { routes } from "../../common/api/routes";
import { setResults, setResultsSuccess, getResultsError, getResultsDetail, getResultsDetailSuccess, getResultsDetailError, interestedCareer, saveInterestedCareerSuccess, saveInterestedCareerError } from "../actions";

export function* setResultsSaga({ payload }) {
  yield put(setResults())
  try {
    const response = yield call(routes.setResults, payload.id, { score: payload.score, booked: payload.booked });
    yield put(setResultsSuccess(response));
  } catch (error) {
    yield put(getResultsError(error));
  }
}

export function* setResultsDetailSaga({ id }) {
  yield put(getResultsDetail())
  try {
    const response = yield call(routes.setResultsDetail, id);
    yield put(getResultsDetailSuccess(response));
  } catch (error) {
    yield put(getResultsDetailError(error));
  }
}

export function* saveInterestedCareer({ payload }) {
  yield put(interestedCareer())
  try {
    const response = yield call(routes.setResults, payload.id, {
      interested: payload.interested,
      ...(payload.sort_decision != null ? { sort_decision: payload.sort_decision } : {}),
    })
    yield put(saveInterestedCareerSuccess(response))
  } catch (error) {
    yield put(saveInterestedCareerError(error))
  }
}